
import Vue, {
  PropType,
} from "vue";

import {
  View,
} from "@/Enums";

import LocalChanger from "./LocalChanger.vue";

import {
  PolicyConstants,
} from "@/authorization/constants/PolicyConstants";

import {
  PermissionConstants,
} from "@/authorization/constants/PermissionConstants";

import {
  getCurrentLoggedInUsername,
  hasAccessRights,
} from "@/authorization/AuthorizationService";

import {
  readSettingsPolicy,
} from "@/authorization/policies/settingDataPolicies";

import {
  readCardsPolicy,
} from "@/authorization/policies/administrateCardsPolicy";

import {
  readIssuersPolicy,
} from "@/authorization/policies/issuerDataPolicy";

import {
  clearStorage,
} from "@/scripts/Common/componentStorage";

import {
  getAccessRights,
} from "@/authorization/getAccessRights";

import {
  accountDataPolicies,
  customerDataPolicies,
  operatorDataPolicies,
} from "@/authorization/policies";
import {reportPolicies} from "@/authorization/policies/reportPolicies";


export default Vue.extend({
  components: {
    LocalChanger,
  },
  props: {
    Permissions: {
      required: true,
      type: Map as PropType<Map<string, Map<string, boolean>>>
    },
    SelectedView: {
      required: true,
      type: Number as PropType<View>,
    },
  },
  data: () => ({
    View,
    dialogLogout: false,
    userPermissions: new Map()
  }),
  computed: {
    CurrentView() {
      return this.SelectedView;
    },
    versionNumber() {
      let packageInfo = require('../../package.json')
      return packageInfo.version;
    },
    MenuItems() {
      this.userPermissions = this.Permissions;
      return [
        {
          title: this.$t("operator"),
          icon: "mdi-account-tie",
          view: View.Operator,
          authorized: getAccessRights(operatorDataPolicies).hasReadRights
        },
        {
          title: this.$t("customers"),
          icon: "mdi-cash-register",
          subitems: [
            {
              title: this.$t("customer_list"),
              icon: "mdi-format-list-bulleted",
              view: View.Customer,
              authorized: getAccessRights(customerDataPolicies).hasReadRights
            },
            {
              title: this.$t("customer_core_data"),
              icon: "mdi-account-tie",
              view: View.CustomerCoreData,
              authorized: getAccessRights(customerDataPolicies).hasReadRights
            },
          ],
          authorized: getAccessRights(customerDataPolicies).hasReadRights
        },
        {
          title: this.$t("issuers"),
          icon: "mdi-badge-account-horizontal",
          subitems: [
            {
              title: this.$t("issuer_list"),
              icon: "mdi-format-list-bulleted",
              view: View.Issuer,
              authorized: hasAccessRights(readIssuersPolicy)
            },
            {
              title: this.$t("issuer_core_data"),
              icon: "mdi-account-tie",
              view: View.IssuerCoreData,
              authorized: hasAccessRights(readIssuersPolicy)
            },
            {
              title: this.$t("issuer_cards"),
              icon: "mdi-card-plus",
              view: View.AdministerIssuerCards,
              authorized: hasAccessRights(readIssuersPolicy)
            },
            {
              title: this.$t("issuer_webcharges"),
              icon: "mdi-cash-plus",
              view: View.AdministerIssuerWebcharges,
              authorized: hasAccessRights(readIssuersPolicy)
            },
            {
              title: this.$t("issuer_reports"),
              icon: "mdi-file",
              view: View.IssuerReports,
              authorized: hasAccessRights(readIssuersPolicy)
            },
            {
              title: this.$t("issuer_user_management"),
              icon: "mdi-account-multiple-outline",
              view: View.IssuerUserManagement,
              authorized: hasAccessRights(readIssuersPolicy)
            },
          ],
          authorized: hasAccessRights(readIssuersPolicy)
        },
        {
          title: this.$t("card_users"),
          icon: "mdi-card-account-details",
          view: View.CardUsers,
          subitems: [
            {
              title: this.$t("card_users_list"),
              icon: "mdi-format-list-bulleted",
              view: View.CardUsers,
              authorized: hasAccessRights(readIssuersPolicy)
            },
            {
              title: this.$t("card_users_core_data"),
              icon: "mdi-account-tie",
              view: View.CardUserCoreData,
              authorized: hasAccessRights(readIssuersPolicy)
            },
          ],
          authorized: hasAccessRights(readIssuersPolicy)
        },
        {
          title: this.$t("sepa_documents"),
          icon: "mdi-cash-check",
          subitems: [
            {
              title: this.$t("sepa_documents_customers"),
              icon: "mdi-bank-transfer",
              view: View.CustomerBankTransfers,
              authorized: this.userPermissions.get(PolicyConstants.SEPA_POLICIES).get(PermissionConstants.READ)
            },
            {
              title: this.$t("sepa_documents_issuers"),
              icon: "mdi-bank-transfer",
              view: View.IssuerBankTransfers,
              authorized: this.userPermissions.get(PolicyConstants.SEPA_POLICIES).get(PermissionConstants.READ)
            },
          ],
          authorized: this.userPermissions.get(PolicyConstants.SEPA_POLICIES).get(PermissionConstants.READ)
        },
        {
          title: this.$t("reports"),
          icon: "mdi-file-chart",
          view: View.Report,
          authorized: getAccessRights(reportPolicies).hasReadRights
        },
        {
          title: this.$t("administration"),
          icon: "mdi-tune",
          subitems: [
            {
              title: this.$t("administration_cards"),
              icon: "mdi-id-card",
              view: View.AdministerCards,
              authorized: hasAccessRights(readCardsPolicy)
            },
            {
              title: this.$t("administration_proficontrol_users"),
              icon: "mdi-account-edit",
              view: View.ProfiControlUser,
              authorized: this.userPermissions.get(PolicyConstants.SYSTEM_ADMINISTRATION_POLICIES).get(PermissionConstants.READ)
            },
            {
              title: this.$t("administration_password_reset"),
              icon: "mdi-account-reactivate",
              view: View.PasswordResetOverview,
              authorized: getAccessRights(accountDataPolicies).hasReadRights
            },
            {
              title: this.$t("administration_imports"),
              icon: "mdi-file-import-outline",
              view: View.AdminImports,
              authorized: this.userPermissions.get(PolicyConstants.SYSTEM_ADMINISTRATION_POLICIES).get(PermissionConstants.EDIT)
            },
          ].filter(m => m.authorized === true),
          authorized: this.userPermissions.get(PolicyConstants.SYSTEM_ADMINISTRATION_POLICIES).get(PermissionConstants.READ) ||
            getAccessRights(accountDataPolicies).hasReadRights
        },
        {
          title: this.$t("settings"),
          icon: "mdi-cog-outline",
          subitems: [
            {
              title: this.$t("settings_webcharges"),
              icon: "mdi-cash-lock",
              view: View.WebChargeConfigurationOverview,
              authorized: hasAccessRights(readSettingsPolicy)
            },
            {
              title: this.$t("settings_gratifications"),
              icon: "mdi-star",
              view: View.GratificationSettings,
              authorized: hasAccessRights(readSettingsPolicy)
            },
            {
              title: this.$t("settings_sepa_documents"),
              icon: "mdi-file-settings-outline",
              view: View.SepaSettings,
              authorized: hasAccessRights(readSettingsPolicy)
            },
            {
              title: this.$t("settings_vat_details"),
              icon: "mdi-bank",
              view: View.VatSettings,
              authorized: hasAccessRights(readSettingsPolicy)
            }
          ].filter(m => m.authorized),
          authorized: hasAccessRights(readSettingsPolicy)
        },
        {
          title: this.$t("user_account"),
          icon: "mdi-account",
          subitems: [
            {
              title: this.$t("user_account_password_change"),
              icon: "mdi-clipboard-edit",
              view: View.ChangePassword,
            },
          ],
        },
      ].filter(m => m.authorized === true || m.authorized === undefined);
    },
  },
  methods: {
    getCurrentLoggedInUsername,
    OnClick: function (view: View) {
      this.$emit("menu-item-clicked", view);
    },
    Logout: function () {
      this.dialogLogout = true;
    },
    LogoutConfirm: function () {
      this.dialogLogout = false;
      clearStorage();
      this.$emit("menu-item-clicked", View.Login);
    },
    HasSubItems(item: any): boolean {
      return item.subitems?.length > 0;
    },
  },
});
